import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const HeaderContainer = styled.header`
  background-color: #000000;
  color: #ffffff;
  position: sticky;
  top: 0;
  z-index: 1000;
`;

export const HeaderContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Logo = styled.div`
  font-size: 1.5rem;
  font-weight: 700;
  color: #f5f5f5;
  display: flex;
  align-items: center;
  gap: 12px;
  max-width: 50%;
  line-height: 1.2;
`;

export const Nav = styled.nav`
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
    position: absolute;
    top: 72px;
    left: 0;
    right: 0;
    flex-direction: column;
    background-color: #000000;
    padding: 16px 20px 24px;
  }
`;

export const NavList = styled.ul`
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 16px;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
  }
`;

export const NavItem = styled.li`
  position: relative;
 
  &:hover > ul {
    display: block;
  }
`;

export const NavLink = styled(Link)`
  display: inline-block;
  padding: 8px 12px;
  border-radius: 6px;
  text-decoration: none;
  color: #ffffff;
  font-size: 0.95rem;
  font-weight: 500;
  transition: all 0.2s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.08);
    color: #f5f5f5;
  }

  &.active {
    background-color: #d4af37;
    color: #000000;
  }

  &.has-dropdown::after {
    content: '▾';
    font-size: 0.7rem;
    margin-left: 4px;
  }

  @media (max-width: 768px) {
    display: block;
    width: 100%;
    text-align: center;
  }
`;

export const DropdownMenu = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  margin: 0;
  padding: 8px 0;
  list-style: none;
  min-width: 200px;
  background-color: #ffffff;
  color: #000000;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  display: none;
  z-index: 1200;

  @media (max-width: 768px) {
    position: static;
    box-shadow: none;
    background-color: #000000;
    color: #ffffff;
    padding: 4px 0 0 12px;
    display: block;
  }
`;

export const DropdownItem = styled.li`
  padding: 0;
`;

export const DropdownLink = styled(NavLink)`
  display: block;
  width: 100%;
  padding: 8px 16px;
  border-radius: 0;
  color: #333333;
  background-color: transparent;

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
    color: #000000;
  }

  &.active {
    background-color: #f5f5f5;
    color: #000000;
  }

  @media (max-width: 768px) {
    color: #ffffff;

    &:hover {
      background-color: rgba(255, 255, 255, 0.08);
      color: #f5f5f5;
    }
  }
`;

export const MobileMenuButton = styled.button`
  display: none;
  background: none;
  border: 1px solid #ffffff;
  color: #ffffff;
  padding: 6px 10px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;

  @media (max-width: 768px) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
`;

export const ContactInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 0.85rem;

  @media (max-width: 900px) {
    display: none;
  }
`;

export const ContactItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: #f5f5f5;

  svg {
    width: 16px;
    height: 16px;
  }
`;
